// app/javascript/modules/admissoes/beneficios.js
export function initBeneficios($form, h) {
  const { hide, show, uncheckByName, clearValue } = h
  const ns = ".admissaoBeneficios"

  // --- helpers locais (não dependem do crud/form_controller) ---
  function $wrap(cls) { return $form.find(cls) }

  function setRequired($el, on) {
    if (!$el || $el.length === 0) return
    $el.prop("required", !!on)
    if (on) $el.attr("aria-required", "true")
    else $el.removeAttr("aria-required")
  }

  function setEnabled($el, on, { clearOnDisable = true } = {}) {
    if (!$el || $el.length === 0) return
    // disabled resolve 90% dos casos; readonly ajuda quando há máscaras
    $el.prop("disabled", !on)
    $el.prop("readonly", !on)
    if (!on && clearOnDisable) $el.val("")
  }

  function hideWrapAndDisable($wrapper, $inputs, { clear = true } = {}) {
    hide($wrapper)
    setEnabled($inputs, false, { clearOnDisable: clear })
    setRequired($inputs, false)
  }

  function showWrapAndEnable($wrapper, $inputs, { required = false } = {}) {
    show($wrapper)
    setEnabled($inputs, true, { clearOnDisable: false })
    setRequired($inputs, required)
  }

  // Esconde wrapper e remove required dos inputs internos, salvando estado via data-conditional-required
  function hideWrapOnly($wrapper) {
    hide($wrapper)
    $wrapper.find("input, select, textarea").each(function() {
      const $el = $form.constructor(this) // usa o jQuery já disponível via $form (evita dependência do $ global)
      if ($el.prop("required")) {
        $el.attr("data-conditional-required", "true")
      }
      $el.prop("required", false).removeAttr("aria-required")
    })
  }

  // Mostra wrapper e restaura required nos inputs que tinham data-conditional-required
  function showWrapOnly($wrapper) {
    show($wrapper)
    $wrapper.find("[data-conditional-required='true']").prop("required", true).attr("aria-required", "true")
  }

  // --- máscara dinâmica (money <-> percent) ---
  function applyMaskKind($input, kind /* 'money'|'percent' */) {
    if (!$input || $input.length === 0) return
    $input.attr("data-crud--mask-kind-value", kind)
    if (kind === "percent") {
      $input.attr("placeholder", "0%")
    } else {
      const withPrefix = $input.attr("data-crud--mask-prefix-value") === "true"
      $input.attr("placeholder", withPrefix ? "R$ 0,00" : "0,00")
    }
    // raf garante que o Stimulus crud--mask já conectou antes de aplicar
    requestAnimationFrame(() => $input.trigger("blur"))
  }

  // inputs por id (como você já usa em clearValue)
  function $inputById(id) { return $form.find(id) }

  function syncPossuiValeTransporte() {
    const val = $form.find('input[name="params[possui_vale_transporte]"]:checked').val()

    const $secaoTransporte = $form.find("#secao-transporte-campos")
    const $wBilhete  = $wrap(".possui_cartao_bilhete_unico")
    const $wNumCartao = $wrap(".params_numero_cartao_vale_transporte")
    const $wDesvinc  = $wrap(".params_esta_desvinculado_da_empresa_anterior")
    const $wContato  = $wrap(".params_entrar_em_contato_antiga_empresa")
    const $numCartao = $inputById("#params_numero_cartao_vale_transporte")

    if (val === "Sim") {
      show($secaoTransporte)
      // re-habilita tudo; syncPossuiCartaoBilheteUnico corrige o estado dos sub-campos
      $secaoTransporte.find("input, select").prop("disabled", false)
      showWrapOnly($wBilhete)
      showWrapOnly($wDesvinc)
      syncPossuiCartaoBilheteUnico()
    } else {
      hide($secaoTransporte)
      $secaoTransporte.find("input, select").prop("disabled", true)
      uncheckByName("params[possui_cartao_bilhete_unico]")
      clearValue("#params_numero_cartao_vale_transporte")
      uncheckByName("params[esta_desvinculado_da_empresa_anterior]")
    }
  }

  function syncPossuiCartaoBilheteUnico() {
    const val = $form.find('input[name="params[possui_cartao_bilhete_unico]"]:checked').val()

    const $wNumCartao = $wrap(".params_numero_cartao_vale_transporte")
    const $wDesvinc = $wrap(".params_esta_desvinculado_da_empresa_anterior")
    const $wContato = $wrap(".params_entrar_em_contato_antiga_empresa")

    const $numCartao = $inputById("#params_numero_cartao_vale_transporte")

    if (val === "Sim") {
      // aqui geralmente passa a fazer sentido exigir o número (se essa for a regra)
      showWrapAndEnable($wNumCartao, $numCartao, { required: true })
      showWrapOnly($wDesvinc)
    } else {
      hideWrapAndDisable($wNumCartao, $numCartao)
      hideWrapOnly($wDesvinc)
      hideWrapOnly($wContato)

      uncheckByName("params[esta_desvinculado_da_empresa_anterior]")
      clearValue("#params_numero_cartao_vale_transporte")
    }
  }

  function syncEstaDesvinculadoEmpresaAnterior() {
    const val = $form.find('input[name="params[esta_desvinculado_da_empresa_anterior]"]:checked').val()
    const $wContato = $wrap(".params_entrar_em_contato_antiga_empresa")

    if (val === "Não") showWrapOnly($wContato)
    else hideWrapOnly($wContato)
  }

  function syncAssistenciaMedica() {
    const val = $form.find('input[name="params[assistencia_medica]"]:checked').val()

    const $wPart = $wrap(".params_participacao_empregado")
    const $wPerc = $wrap(".params_participacao_empregado_percentual")
    const $perc = $inputById("#params_participacao_empregado_percentual")

    if (val === "Sim") {
      // Mostra só o rádio de participação.
      // O percentual SÓ deve aparecer quando participacao_empregado == "Sim".
      show($wPart)
      hideWrapAndDisable($wPerc, $perc) // ✅ garante que não abre “sozinho” na 1ª vez
      clearValue("#params_participacao_empregado_percentual")
    } else {
      hide($wPart)
      hideWrapAndDisable($wPerc, $perc)
      uncheckByName("params[participacao_empregado]")
      clearValue("#params_participacao_empregado_percentual")
    }
  }

  function syncParticipacaoEmpregado() {
    const val = $form.find('input[name="params[participacao_empregado]"]:checked').val()

    const $wPerc = $wrap(".params_participacao_empregado_percentual")
    const $perc = $inputById("#params_participacao_empregado_percentual")

    // ✅ Se não tem escolha ainda, NÃO mostra percentual.
    if (!val) {
      hideWrapAndDisable($wPerc, $perc)
      clearValue("#params_participacao_empregado_percentual")
      return
    }

    if (val === "Sim") {
      showWrapAndEnable($wPerc, $perc, { required: true })
      applyMaskKind($perc, "percent")
    } else {
      hideWrapAndDisable($wPerc, $perc)
      clearValue("#params_participacao_empregado_percentual")
    }
  }

  function syncTicketAlimentacao() {
    const val = $form.find('input[name="params[ticket_alimentacao]"]:checked').val()

    const $wValor = $wrap(".params_valor_ticket_alimentacao")
    const $valor = $inputById("#params_valor_ticket_alimentacao")
    const $secao = $form.find("#secao-desconto-alimentacao")

    if (val === "Diário" || val === "Mensal") {
      showWrapAndEnable($wValor, $valor, { required: true })
      show($secao)
      syncDescontaAlimentacaoEmContracheque()
    } else {
      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_valor_ticket_alimentacao")
      hide($secao)
      uncheckByName("params[desconta_alimentacao_em_contracheque]")
      hide($form.find("#secao-tipo-desconto-alimentacao"))
      uncheckByName("params[tipo_desconto_alimentacao]")
      hide($form.find("#secao-valor-desconto-alimentacao"))
      setEnabled($inputById("#params_desconto_alimentacao"), false)
      clearValue("#params_desconto_alimentacao")
    }
  }

  function syncTicketRefeicao() {
    const val = $form.find('input[name="params[ticket_refeicao]"]:checked').val()

    const $wValor = $wrap(".params_valor_ticket_refeicao")
    const $valor = $inputById("#params_valor_ticket_refeicao")
    const $secao = $form.find("#secao-desconto-refeicao")

    if (val === "Diário" || val === "Mensal") {
      showWrapAndEnable($wValor, $valor, { required: true })
      show($secao)
      syncDescontaRefeicaoEmContracheque()
    } else {
      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_valor_ticket_refeicao")
      hide($secao)
      uncheckByName("params[desconta_refeicao_em_contracheque]")
      hide($form.find("#secao-tipo-desconto-refeicao"))
      uncheckByName("params[tipo_desconto_refeicao]")
      hide($form.find("#secao-valor-desconto-refeicao"))
      setEnabled($inputById("#params_desconto_refeicao"), false)
      clearValue("#params_desconto_refeicao")
    }
  }

  function syncDescontaAlimentacaoEmContracheque() {
    const val = $form.find('input[name="params[desconta_alimentacao_em_contracheque]"]:checked').val()

    const $secaoTipo = $form.find("#secao-tipo-desconto-alimentacao")
    const $secaoValor = $form.find("#secao-valor-desconto-alimentacao")
    const $valor = $inputById("#params_desconto_alimentacao")

    if (val === "Sim") {
      show($secaoTipo)
      syncTipoDescontoAlimentacao()
    } else {
      hide($secaoTipo)
      uncheckByName("params[tipo_desconto_alimentacao]")
      hide($secaoValor)
      setEnabled($valor, false)
      clearValue("#params_desconto_alimentacao")
      applyMaskKind($valor, "money")
    }
  }

  function syncTipoDescontoAlimentacao() {
    const val = $form.find('input[name="params[tipo_desconto_alimentacao]"]:checked').val()

    const $secaoValor = $form.find("#secao-valor-desconto-alimentacao")
    const $valor = $inputById("#params_desconto_alimentacao")

    if (val === "Valor (R$)") {
      show($secaoValor)
      setEnabled($valor, true, { clearOnDisable: false })
      setRequired($valor, true)
      applyMaskKind($valor, "money")
    } else if (val === "Percentual (%)") {
      show($secaoValor)
      setEnabled($valor, true, { clearOnDisable: false })
      setRequired($valor, true)
      applyMaskKind($valor, "percent")
    } else {
      hide($secaoValor)
      setEnabled($valor, false)
      clearValue("#params_desconto_alimentacao")
    }
  }

  function syncDescontaRefeicaoEmContracheque() {
    const val = $form.find('input[name="params[desconta_refeicao_em_contracheque]"]:checked').val()

    const $secaoTipo = $form.find("#secao-tipo-desconto-refeicao")
    const $secaoValor = $form.find("#secao-valor-desconto-refeicao")
    const $valor = $inputById("#params_desconto_refeicao")

    if (val === "Sim") {
      show($secaoTipo)
      syncTipoDescontoRefeicao()
    } else {
      hide($secaoTipo)
      uncheckByName("params[tipo_desconto_refeicao]")
      hide($secaoValor)
      setEnabled($valor, false)
      clearValue("#params_desconto_refeicao")
      applyMaskKind($valor, "money")
    }
  }

  function syncTipoDescontoRefeicao() {
    const val = $form.find('input[name="params[tipo_desconto_refeicao]"]:checked').val()

    const $secaoValor = $form.find("#secao-valor-desconto-refeicao")
    const $valor = $inputById("#params_desconto_refeicao")

    if (val === "Valor (R$)") {
      show($secaoValor)
      setEnabled($valor, true, { clearOnDisable: false })
      setRequired($valor, true)
      applyMaskKind($valor, "money")
    } else if (val === "Percentual (%)") {
      show($secaoValor)
      setEnabled($valor, true, { clearOnDisable: false })
      setRequired($valor, true)
      applyMaskKind($valor, "percent")
    } else {
      hide($secaoValor)
      setEnabled($valor, false)
      clearValue("#params_desconto_refeicao")
    }
  }

  function syncTicketCestaBasica() {
    const val = $form.find('input[name="params[ticket_cesta_basica]"]:checked').val()

    const $wValor = $wrap(".params_valor_ticket_cesta_basica")
    const $valor = $inputById("#params_valor_ticket_cesta_basica")
    const $secao = $form.find("#secao-desconto-cesta-basica")

    if (val === "Diário" || val === "Mensal") {
      showWrapAndEnable($wValor, $valor, { required: true })
      show($secao)
      syncDescontaCestaBasicaEmContracheque()
    } else {
      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_valor_ticket_cesta_basica")
      hide($secao)
      uncheckByName("params[desconta_cesta_basica_em_contracheque]")
      hide($form.find("#secao-tipo-desconto-cesta-basica"))
      uncheckByName("params[tipo_desconto_cesta_basica]")
      hide($form.find("#secao-valor-desconto-cesta-basica"))
      setEnabled($inputById("#params_desconto_cesta_basica"), false)
      clearValue("#params_desconto_cesta_basica")
    }
  }

  function syncDescontaCestaBasicaEmContracheque() {
    const val = $form.find('input[name="params[desconta_cesta_basica_em_contracheque]"]:checked').val()

    const $secaoTipo = $form.find("#secao-tipo-desconto-cesta-basica")
    const $secaoValor = $form.find("#secao-valor-desconto-cesta-basica")
    const $valor = $inputById("#params_desconto_cesta_basica")

    if (val === "Sim") {
      show($secaoTipo)
      syncTipoDescontoCestaBasica()
    } else {
      hide($secaoTipo)
      uncheckByName("params[tipo_desconto_cesta_basica]")
      hide($secaoValor)
      setEnabled($valor, false)
      clearValue("#params_desconto_cesta_basica")
      applyMaskKind($valor, "money")
    }
  }

  function syncTipoDescontoCestaBasica() {
    const val = $form.find('input[name="params[tipo_desconto_cesta_basica]"]:checked').val()

    const $secaoValor = $form.find("#secao-valor-desconto-cesta-basica")
    const $valor = $inputById("#params_desconto_cesta_basica")

    if (val === "Valor (R$)") {
      show($secaoValor)
      setEnabled($valor, true, { clearOnDisable: false })
      setRequired($valor, true)
      applyMaskKind($valor, "money")
    } else if (val === "Percentual (%)") {
      show($secaoValor)
      setEnabled($valor, true, { clearOnDisable: false })
      setRequired($valor, true)
      applyMaskKind($valor, "percent")
    } else {
      hide($secaoValor)
      setEnabled($valor, false)
      clearValue("#params_desconto_cesta_basica")
    }
  }

  function syncDescontaEmContracheque() {
    const val = $form.find('input[name="params[desconta_em_contracheque]"]:checked').val()

    const $wTipo = $wrap(".params_tipo_desconto_contracheque")
    const $wValor = $wrap(".params_desconto_em_contracheque")
    const $valor = $inputById("#params_desconto_em_contracheque")

    if (val === "Sim") {
      show($wTipo)
      // tipo passa a ser required; como é check_box_multiplo, required no input não ajuda muito,
      // mas manter o wrapper visível e limpar quando desliga já resolve validação de “campo escondido”.
    } else {
      hide($wTipo)
      uncheckByName("params[tipo_desconto_contracheque]")

      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_desconto_em_contracheque")
      // volta para money por padrão (evita ficar “percent” na próxima vez)
      applyMaskKind($valor, "money")
    }
  }

  function syncTipoDescontoContracheque() {
    const val = $form.find('input[name="params[tipo_desconto_contracheque]"]:checked').val()

    const $wValor = $wrap(".params_desconto_em_contracheque")
    const $valor = $inputById("#params_desconto_em_contracheque")

    if (val === "Valor (R$)") {
      showWrapAndEnable($wValor, $valor, { required: true })
      applyMaskKind($valor, "money")
    } else if (val === "Percentual (%)") {
      showWrapAndEnable($wValor, $valor, { required: true })
      applyMaskKind($valor, "percent")
    } else {
      hideWrapAndDisable($wValor, $valor)
      clearValue("#params_desconto_em_contracheque")
    }
  }

  function apply() {
    syncPossuiValeTransporte()
    syncPossuiCartaoBilheteUnico()
    syncEstaDesvinculadoEmpresaAnterior()
    syncAssistenciaMedica()
    syncParticipacaoEmpregado()
    syncTicketAlimentacao()
    syncTicketRefeicao()
    syncTicketCestaBasica()
    syncDescontaEmContracheque()
    syncTipoDescontoContracheque()
    syncDescontaAlimentacaoEmContracheque()
    syncTipoDescontoAlimentacao()
    syncDescontaRefeicaoEmContracheque()
    syncTipoDescontoRefeicao()
    syncDescontaCestaBasicaEmContracheque()
    syncTipoDescontoCestaBasica()
  }

  // --- validação de desconto PAT (limite 20% do valor do benefício — CLT/PAT vigente) ---
  const $jQuery = $form.constructor  // jQuery constructor — evita depender do $ global

  // Converte valor em formato BR ("1.500,00" ou "R$ 1.500,00") para float
  function parseBRMoney(val) {
    return parseFloat(String(val || "").replace(/[R$\s.]/g, "").replace(",", ".")) || 0
  }

  // maxPct: limite legal (20 para benefícios PAT)
  // ticketValueId: seletor do input com o valor do benefício (para validar modo Valor R$)
  function criaValidadorDesconto(inputId, tipoName, flagKey, { maxPct = 100, ticketValueId = null } = {}) {
    const $input = $inputById(inputId)
    if (!$input.length) return () => {}

    const alertId = `${inputId.replace('#', '')}-pct-alerta`
    let $alerta = $form.find(`#${alertId}`)
    if (!$alerta.length) {
      $alerta = $jQuery(`<div id="${alertId}" class="hidden mt-1 rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-700"></div>`)
      $input.closest("div").after($alerta)
    }

    function tipoSelecionado() {
      return $form.find(`input[name="${tipoName}"]:checked`).val()
    }

    function parsePct(val) {
      return parseFloat(String(val || "").replace(",", "."))
    }

    function fmtBRL(v) {
      return v.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }

    function erro(msg) {
      $alerta.removeClass("hidden").html(`<i class="fas fa-exclamation-circle mr-1"></i>${msg}`)
      $form.data(flagKey, true)
    }

    function ok() {
      $alerta.addClass("hidden").empty()
      $form.data(flagKey, false)
    }

    function valida() {
      if ($input.is(":disabled")) { ok(); return }

      const tipo = tipoSelecionado()

      if (tipo === "Percentual (%)") {
        const v = parsePct($input.val())
        if (isNaN(v) || v <= 0) {
          erro(`Informe um percentual entre <strong>1%</strong> e <strong>${maxPct}%</strong>.`)
        } else if (v > maxPct) {
          erro(`O desconto em contracheque é limitado a <strong>${maxPct}%</strong> do valor do benefício (CLT/PAT).`)
        } else {
          ok()
        }
      } else if (tipo === "Valor (R$)" && ticketValueId) {
        const ticketVal = parseBRMoney($form.find(ticketValueId).val())
        const descontoVal = parseBRMoney($input.val())
        if (ticketVal > 0 && descontoVal > 0) {
          const maxDesconto = ticketVal * (maxPct / 100)
          if (descontoVal > maxDesconto) {
            erro(`O desconto máximo é <strong>R$ ${fmtBRL(maxDesconto)}</strong> (${maxPct}% de R$ ${fmtBRL(ticketVal)} — CLT/PAT).`)
          } else {
            ok()
          }
        } else {
          ok()
        }
      } else {
        ok()
      }
    }

    const evNs = `${ns}Pct`
    $input.off(`input${evNs} change${evNs} blur${evNs}`)
      .on(`input${evNs} change${evNs} blur${evNs}`, valida)

    return valida
  }

  const validaDescontoAlimentacao = criaValidadorDesconto(
    "#params_desconto_alimentacao",
    "params[tipo_desconto_alimentacao]",
    "desconto-alimentacao-bloqueado",
    { maxPct: 20, ticketValueId: "#params_valor_ticket_alimentacao" }
  )
  const validaDescontoRefeicao = criaValidadorDesconto(
    "#params_desconto_refeicao",
    "params[tipo_desconto_refeicao]",
    "desconto-refeicao-bloqueado",
    { maxPct: 20, ticketValueId: "#params_valor_ticket_refeicao" }
  )
  const validaDescontoCestaBasica = criaValidadorDesconto(
    "#params_desconto_cesta_basica",
    "params[tipo_desconto_cesta_basica]",
    "desconto-cesta-basica-bloqueado",
    { maxPct: 20, ticketValueId: "#params_valor_ticket_cesta_basica" }
  )

  $form.off(ns)
  $form.on(`change${ns}`, 'input[name="params[possui_vale_transporte]"]', syncPossuiValeTransporte)
  $form.on(`change${ns}`, 'input[name="params[possui_cartao_bilhete_unico]"]', syncPossuiCartaoBilheteUnico)
  $form.on(`change${ns}`, 'input[name="params[esta_desvinculado_da_empresa_anterior]"]', syncEstaDesvinculadoEmpresaAnterior)
  $form.on(`change${ns}`, 'input[name="params[assistencia_medica]"]', syncAssistenciaMedica)
  $form.on(`change${ns}`, 'input[name="params[participacao_empregado]"]', syncParticipacaoEmpregado)
  $form.on(`change${ns}`, 'input[name="params[ticket_alimentacao]"]', () => { syncTicketAlimentacao(); validaDescontoAlimentacao() })
  $form.on(`change${ns}`, 'input[name="params[ticket_refeicao]"]', () => { syncTicketRefeicao(); validaDescontoRefeicao() })
  $form.on(`change${ns}`, 'input[name="params[desconta_em_contracheque]"]', syncDescontaEmContracheque)
  $form.on(`change${ns}`, 'input[name="params[tipo_desconto_contracheque]"]', syncTipoDescontoContracheque)
  $form.on(`change${ns}`, 'input[name="params[desconta_alimentacao_em_contracheque]"]', () => { syncDescontaAlimentacaoEmContracheque(); validaDescontoAlimentacao() })
  $form.on(`change${ns}`, 'input[name="params[tipo_desconto_alimentacao]"]', () => { syncTipoDescontoAlimentacao(); validaDescontoAlimentacao() })
  $form.on(`input${ns}`, '#params_valor_ticket_alimentacao', () => { validaDescontoAlimentacao() })
  $form.on(`change${ns}`, 'input[name="params[desconta_refeicao_em_contracheque]"]', () => { syncDescontaRefeicaoEmContracheque(); validaDescontoRefeicao() })
  $form.on(`change${ns}`, 'input[name="params[tipo_desconto_refeicao]"]', () => { syncTipoDescontoRefeicao(); validaDescontoRefeicao() })
  $form.on(`input${ns}`, '#params_valor_ticket_refeicao', () => { validaDescontoRefeicao() })
  $form.on(`change${ns}`, 'input[name="params[ticket_cesta_basica]"]', () => { syncTicketCestaBasica(); validaDescontoCestaBasica() })
  $form.on(`change${ns}`, 'input[name="params[desconta_cesta_basica_em_contracheque]"]', () => { syncDescontaCestaBasicaEmContracheque(); validaDescontoCestaBasica() })
  $form.on(`change${ns}`, 'input[name="params[tipo_desconto_cesta_basica]"]', () => { syncTipoDescontoCestaBasica(); validaDescontoCestaBasica() })
  $form.on(`input${ns}`, '#params_valor_ticket_cesta_basica', () => { validaDescontoCestaBasica() })

  $form.off("submit.benefDesconto").on("submit.benefDesconto", function (e) {
    if ($form.data("desconto-alimentacao-bloqueado") || $form.data("desconto-refeicao-bloqueado") || $form.data("desconto-cesta-basica-bloqueado")) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  })

  return {
    apply,
    destroy() {
      $form.off(ns)
      $form.off("submit.benefDesconto")
    }
  }
}
